import {WizardStates, WizardUiState}     from './WizardStates';
import {ApDynformsConfigFieldset}        from '../../../../ap-dynforms/config/ap-dynforms-config-fieldset';
import {Observable, of}                  from 'rxjs';
import {ApDynGridColumnConfigBase}       from '../../../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {ApDynGridPagerConfigBase}        from '../../../../ap-dyngrids/config/ap-dyn-grid-pager-config-base';
import {ApDynformsConfigPlaceholder}     from '../../../../ap-dynforms/config/ap-dynforms-config-placeholder';
import {ApDynformsConfigComboBox}        from '../../../../ap-dynforms/config/ap-dynforms-config-combobox';
import {ApDynformsConfigDatepicker}      from '../../../../ap-dynforms/config/ap-dynforms-config-datepicker';
import {ApDynformsValidator}             from '../../../../ap-dynforms/ap-dynforms-validator';
import {Validators}                      from '@angular/forms';
import {TaskManagementDataProviders}     from '../../../task-management-data-providers/task-management-data-providers';
import {ITaskManagementPlanBookGridData} from '../../../task-management.types';
import ITaskManagementPlanSummary = Data.TaskManagement.ITaskManagementPlanSummary;
import IExportFormat = Data.Common.IExportFormat;
import IExportTarget = Data.Common.IExportTarget;

export interface IExportFormatsComboData extends IExportFormat {
  Translation: string;
}

export interface IExportTargetsComboData extends IExportTarget {
  Translation: string;
}

export class TaskManagementWizardDetailsConfig implements WizardUiState {

  constructor(private dataProviders: TaskManagementDataProviders,
              private planSummary: ITaskManagementPlanSummary) {
  }

  getFieldsetConfig(data: Array<ITaskManagementPlanBookGridData>): ApDynformsConfigFieldset[] {
    let planBook: ITaskManagementPlanBookGridData;
    if (data && data.length > 0) {
      planBook = data[0];
    }

    return [
      new ApDynformsConfigFieldset({
        key: 'Task_Mgmt_Processing',
        legend: 'Task_Mgmt_Processing',
        config: [
          new ApDynformsConfigComboBox({
            key: 'SourceItem.ExportFormat',
            label: 'Task_Mgmt_Export_Format',
            options: this.dataProviders[this.planSummary.Module].getExportFormats(this.planSummary),
            value: this.getPreselectedExportFormat(planBook),
            valueField: 'Id',
            textField: 'Translation',
            valuePrimitive: false,
            translate: false,
            validators: [
              new ApDynformsValidator({validator: Validators.required, errorKey: 'Settings__Msg_Vali_Value_Required'}),
            ]
          }),
          new ApDynformsConfigComboBox({
            key: 'SelectedExportTargetObject',
            label: 'Task_Mgmt_Export_Target',
            options: this.dataProviders[this.planSummary.Module].getExportTargets(planBook?.SourceItem?.ExportFormat),
            value$: this.dataProviders[this.planSummary.Module].getSelectedExportTarget(planBook?.SourceItem?.ExportTarget),
            valueField: 'Id',
            textField: 'Translation',
            valuePrimitive: false,
            translate: false,
            validators: [
              new ApDynformsValidator({validator: Validators.required, errorKey: 'Settings__Msg_Vali_Value_Required'}),
            ]
          }),
          new ApDynformsConfigDatepicker({
            key: 'ApplDate',
            label: 'Nutrients__FertilizationDate',
            value: planBook?.ApplDate ?? new Date(this.planSummary.ApplDate),
            validators: [
              new ApDynformsValidator({validator: Validators.required, errorKey: 'Settings__Msg_Vali_Value_Required'}),
            ]
          }),
          new ApDynformsConfigPlaceholder(),
          new ApDynformsConfigComboBox({
            key: 'SourceItem.ExportDriver',
            label: 'Docu_Ini__Motorist',
            value: planBook?.SourceItem?.ExportDriver,
            options: this.dataProviders.drivers$,
            valueField: 'Id',
            textField: 'ShortFullName',
            valuePrimitive: false,
            translate: false,
            sort: 1
          }),
          new ApDynformsConfigComboBox({
            key: 'SourceItem.ExportMachine',
            label: 'Base__Engine',
            value: planBook?.SourceItem?.ExportMachine,
            options: this.dataProviders.machines$,
            valueField: 'Id',
            textField: 'NameWithSign',
            valuePrimitive: false,
            translate: false,
            sort: 1
          }),
          new ApDynformsConfigComboBox({
            key: 'SourceItem.ExportInstrument',
            label: 'Docu_Ini__Tool',
            value: planBook?.SourceItem?.ExportInstrument,
            options: this.dataProviders.instruments$,
            valueField: 'Id',
            textField: 'Name',
            valuePrimitive: false,
            translate: false,
            sort: 1
          })
        ]
      }),
    ];
  }

  getGridColumnConfig(): Observable<ApDynGridColumnConfigBase[]> {
    return of([]);
  }

  getPagerConfig(_: WizardStates[]): ApDynGridPagerConfigBase {
    return undefined;
  }

  getPreselectedExportFormat(planBook: ITaskManagementPlanBookGridData): IExportTargetsComboData {
    const allExportFormats = this.dataProviders[this.planSummary.Module].getExportFormats(this.planSummary);
    const selectedExportFormat = allExportFormats.find(_ => _.Id === planBook?.SourceItem?.ExportFormat?.Id);
    return selectedExportFormat ?? allExportFormats[0];
  }
}
